import { useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { mapProps } from "./props-mapper.js";
function useFormValidation(options) {
  const { register, ...restProps } = useForm(options);
  const [fakeToggle, reRender] = useState(false);
  const { formState, getValues, setValue, getFieldState, trigger } = restProps;
  const blurred = useRef(/* @__PURE__ */ new Set());
  function registerField(name, options2) {
    const { errorMessage, propsMapper = "GlInput.v5", ...restOptions } = options2 || {};
    const isActive = blurred.current.has(name) || formState.isSubmitted;
    function extendProps(props) {
      const state = getFieldState(name);
      const error = state.error && {
        ...state.error,
        message: state.error.message || errorMessage
      };
      return {
        ...props,
        value: getValues(name),
        valid: isActive ? !state.invalid : void 0,
        error: isActive ? error : void 0,
        required: typeof (options2 == null ? void 0 : options2.required) === "boolean" && options2.required
      };
    }
    const onChange = (event) => {
      const isCheckbox = event.target.type === "checkbox";
      const value = isCheckbox ? event.target.checked : event.target.value;
      setValue(name, value);
      (options2 == null ? void 0 : options2.onChange) && options2.onChange(event);
      reRender(!fakeToggle);
    };
    const onBlur = (event) => {
      blurred.current.add(name);
      (options2 == null ? void 0 : options2.onBlur) && options2.onBlur(event);
      trigger().then(() => reRender(!fakeToggle));
    };
    return mapProps(
      extendProps(
        register(name, {
          ...restOptions,
          onChange,
          onBlur
        })
      ),
      propsMapper
    );
  }
  return {
    registerField,
    ...restProps
  };
}
export {
  useFormValidation
};
//# sourceMappingURL=validation-hook.js.map
